import { Button } from '@loomhq/lens';
import React from 'react';

import { ADD_VIDEO_TO_TEAM_CARD_KEY } from 'constants/workspaceOnboarding';

import DashboardOnboardingCard from '../../';

import { TeamSvg } from 'components/videos-dashboard-ta/empty-library-ta/icons';
import { launchAddVideoToTeamIntercomTutorial } from 'components/videos-dashboard-ta/onboarding-actions';

const AddVideoToTeamCard = ({ cardConfig }) => {
  const primaryAction = (
    <Button onClick={launchAddVideoToTeamIntercomTutorial}>Show me how</Button>
  );

  return (
    <DashboardOnboardingCard
      cardKey={ADD_VIDEO_TO_TEAM_CARD_KEY}
      cardConfig={cardConfig}
      heading="Add videos to the Team Library"
      description="Organize, edit and manage videos as a team."
      centerpiece={<TeamSvg />}
      primaryAction={primaryAction}
    />
  );
};

export default AddVideoToTeamCard;
